<template>
	<div class="playbooks-table__container">
		<template v-for="card in cards">
			<playbooks-playbook
				v-if="isPlaybook(card.cardType)"
				:key="card.id"
				:template="card"
				class="omapi-card playbooks-card playbooks-card__small"
			/>
			<playbooks-upsell v-else :key="card.slug" :upsell="card" class="playbooks-card playbooks-card__large" />
		</template>
	</div>
</template>

<script>
export default {
	props: {
		cards: {
			type: Array,
			required: true,
		},
	},
	methods: {
		/**
		 * Determine if the card is a playbook (as opposed to an upsell).
		 *
		 * @param {{String}} type The card type.
		 *
		 * @returns {{boolean}} true if the card is a playbook, false otherwise.
		 */
		isPlaybook(type) {
			return 'playbook' === type;
		},
	},
};
</script>
